/* app/js/src/components/common/input/input.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div label {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
  min-width: 90px;
  white-space: nowrap;
}
div input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
div input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
div input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div input.ng-invalid.ng-dirty,
div input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  margin-bottom: 2.5vh;
}
div label {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
div input {
  -webkit-flex: 5 0 0;
  -ms-flex: 5 0 0;
  flex: 5 0 0;
}
div.columnInput {
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
}
div.columnInput label {
  display: block;
  margin-bottom: 12px;
}
div.columnInput input {
  min-height: 30px;
  padding: 0 5px;
}
/*# sourceMappingURL=input.component.css.map */
